export default {
  InputEmpty: "Please enter {name}",
} as const;
